import React from "react";
import { HEXArrowLeft } from "@icons/hexpert/HEXArrowLeft";
import { HEXArrowRight } from "@icons/hexpert/HEXArrowRight";
import './NavigationButton.scss';

type NavigationButtonProps = {
  label: string;
  action: () => void;
  showLeftArrow?: boolean;
};

export const NavigationButton = ({
  label,
  action,
  showLeftArrow,
}: NavigationButtonProps) => {
  return (
    <button className="c-hex-navigation-button" onClick={action}>
      {showLeftArrow && <HEXArrowLeft />}
      {label}
      {!showLeftArrow && <HEXArrowRight />}
    </button>
  );
};
